// Add the two main exports:
export const nistControlsByDomain = {
      'GOVERNANCE': {
        'Program Management (PM)': {
          controls: ['PM-1', 'PM-7', 'PM-9', 'PM-30'],
        },
        'Planning (PL)': { 
          controls: ['PL-1', 'PL-8'],
        },
        'Risk Assessment (RA)': {
          controls: ['RA-1', 'RA-2', 'RA-3'],
        },
        'Assessment, Authorization and Monitoring (CA)': {
          controls: ['CA-7'],
        },
        'Audit and Accountability (AU)': {
          controls: ['AU-1'],
        },
        'System and Communications Protection (SC)': {
          controls: ['SC-1']
        },
        'System & Information Integrity': {
          controls: ['SI-12']
        },
        'Supply Chain Risk Management (SR)': {
          controls: ['SR-1', 'SR-2', 'SR-3', 'SR-6', 'SR-7']
        }
  
      },
      'NETWORK': {
        'Access Control': {
          controls: ['AC-3', 'AC-4', 'AC-17', 'AC-18', 'AC-20'],
        },
        'System & Communications Protection': {
          controls: ['SC-3', 'SC-5', 'SC-7', 'SC-8', 'SC-10', 'SC-12', 'SC-13', 'SC-20', 'SC-23', 'SC-39', 'SC-40'],
        },
        'System & Information Integrity': {
          controls: ['SI-2', 'SI-3', 'SI-4', 'SI-5', 'SI-7',]
        }
      },
      'INFRASTRUCTURE': {
        'Access Control': {
          controls: ['AC-3', 'AC-4', 'AC-6', 'AC-19'],
        },
        'Configuration Management': {
          controls: ['CM-2', 'CM-6', 'CM-7', 'CM-8'],
        },
        'Identification & Authorisation': {
          controls: ['IA-3', 'IA-5'],
        },
        'System & Communications Protection': {
          controls: ['SC-7', 'SC-8', 'SC-28', 'SC-37', 'SC-39'],
        },
        'System & Information Integrity': {
          controls: ['SI-3', 'SI-4', 'SI-7', 'SI-14']
        }
      },
      'APPLICATION': {
        'Access Control': {
          controls: ['AC-2','AC-3', 'AC-4', 'AC-6', 'AC-17', 'AC-19', 'AC-20'],
        },
        'Audit & Accountability': {
          controls: ['AU-2', 'AU-6', 'AU-9'],
        },
        'Configuration Management': {
          controls: ['CM-7'],
        },
        'Identification & Authorisation': {
          controls: ['IA-2', 'IA-3', 'IA-8'],
        },
        'System and Services Acquisition': {
          controls: ['SA-3', 'SA-4', 'SA-5', 'SA-8', 'SA-9', 'SA-10', 'SA-11', 'SA-15', 'SA-17']
        },
        'System & Communications Protection': {
          controls: ['SC-8', 'SC-18', 'SC-28', 'SC-35', 'SC-36'],
        },
        'System & Information Integrity': {
          controls: ['SI-3', 'SI-4', 'SI-7', 'SI-10', 'SI-12']
        }
      },
      'IDENTITY': {
        'Access Control': {
          controls: ['AC-2', 'AC-3', 'AC-6', 'AC-11', 'AC-12', 'AC-17', 'AC-18', 'AC-19'],
        },
        'Identification & Authorisation': {
          controls: ['IA-2', 'IA-3', 'IA-4', 'IA-5', 'IA-8', 'IA-11'],
        },
        'System & Communications Protection': {
          controls: ['SC-8', 'SC-10', 'SC-23'],
        }
      }
};

export const nistControlDetails = {
    // GOVERNANCE CONTROLS //
    'AU-1': {
      name: 'Policies and Procedures',
      family: 'Audit and Accountability',
      description: 'The organization must develop, document, and disseminate comprehensive audit and accountability policies and procedures across appropriate organizational levels. These policies must define purpose, scope, roles, responsibilities, and compliance requirements while aligning with applicable laws and regulations. A designated official must manage these documents, and both policies and procedures must be reviewed and updated at defined intervals and following specified events to maintain their effectiveness.'
    },
    'PM-1': {
      name: 'Information Security Program Plan',
      family: 'Program Management',
      description: 'Develop and disseminate an organization-wide information security program plan that: 1. Provides an overview of the requirements for the security program and describes the security program management controls and common controls in place or planned for meeting those requirements. 2. Includes the identification and assignment of roles, responsibilities, management commitment, coordination among organizational entities, and compliance.'
    },
    'PM-2': {
      name: 'Information Security Program Leadership Role',
      family: 'Program Management',
      description: 'Appoint a senior information security officer with the mission and resources to coordinate, develop, implement, and maintain an organization-wide information security program.'
    },
    'PM-4': {
      name: 'Plan of Action and Milestones Process',
      family: 'Program Management',
      description: 'Implement a process to ensure that plans of action and milestones for the information security, privacy, and supply chain risk management programs and associated organizational systems: (1) Are developed and maintained; (2) Document the remedial information security, privacy, and supply chain risk management actions to adequately respond to risk to organizational operations and assets, individuals, other organizations, and the Nation; and (3) Are reported in accordance with established reporting requirements.'
    },
    'PM-7': {
      name: 'Enterprise Architecture',
      family: 'Program Management',
      description: 'Develop an enterprise architecture with consideration for information security, privacy, and the resulting risk to organizational operations and assets, individuals, other organizations, and the Nation.'
    },
    'PM-9': {
      name: 'Risk Management Strategy',
      family: 'Program Management',
      description: 'Develops a comprehensive strategy to manage: Security risk to organizational operations and assets, individuals, other organizations, and the Nation associated with the operation and use of organizational systems; and Privacy risk to individuals resulting from the authorized processing of personally identifiable information; Implement the risk management strategy consistently across the organization; and Review and update the risk management strategy [Assignment: organization-defined frequency] or as required, to address organizational changes.'
    },
    'PM-28': {
      name: 'Risk Framing',
      family: 'Program Management',
      description: 'Establish and maintain risk framing guidance that includes: the organizational risk assumptions, risk constraints, risk tolerance, and priorities/trade-offs.'
    },
    'PM-30': {
      name: 'Supply Chain Risk Management Strategy',
      family: 'Program Management',
      description: 'Develop an organization-wide strategy for managing supply chain risks associated with the development, acquisition, maintenance, and disposal of systems, system components, and system services; Implement the supply chain risk management strategy consistently across the organization; and Review and update the supply chain risk management strategy on [Assignment: organization-defined frequency] or as required, to address organizational changes.'
    },
    'PL-1': {
      name: 'Security Planning Policy and Procedures',
      family: 'Planning',
      description: 'The organization must:\n' +
          'a) Develop, document, and disseminate to appropriate personnel or roles:\n' +
          '   1. Planning policy at the organization-level, mission/business process-level, and system-level that:\n' +
          '      - Addresses purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance\n' +
          '      - Ensures consistency with applicable laws, executive orders, directives, regulations, policies, standards, and guidelines\n' +
          '   2. Procedures to facilitate the implementation of the planning policy and associated planning controls\n\n' +
          'b) Designate an appropriate organizational official to manage the development, documentation, and dissemination of the planning policy and procedures\n\n' +
          'c) Review and update the current:\n' +
          '   1. Planning policy according to organization-defined frequency and following organization-defined events\n' +
          '   2. Planning procedures according to organization-defined frequency and following organization-defined events'
    },
    'PL-8': {
      name: 'Security and Privacy Architectures',
      family: 'Planning',
      description: 'The organization must:\n' +
          'a) Develop security and privacy architectures for the system that:\n' +
          '   1. Define the requirements and approach for protecting the confidentiality, integrity, and availability of organizational information\n' +
          '   2. Define the requirements and approach for processing personally identifiable information to minimize privacy risk to individuals\n' +
          '   3. Describe how the architectures are integrated into and support the enterprise architecture\n' +
          '   4. Describe any assumptions about, and dependencies on, external systems and services\n\n' +
          'b) Review and update the architectures according to organization-defined frequency to reflect changes in the enterprise architecture\n\n' +
          'c) Reflect planned architecture changes in:\n' +
          '   1. Security and privacy plans\n' +
          '   2. Concept of Operations (CONOPS)\n' +
          '   3. Criticality analysis\n' +
          '   4. Organizational procedures\n' +
          '   5. Procurements and acquisitions'
    },
    // SYSTEM and INFORMATION INTEGRITY (SI)
    'SI-12': {
      name: 'Information Management and Retention',
      family: 'System and Information Integrity',
      description: 'Manage and retain information within the system and information output from the system in accordance with applicable laws, executive orders, directives, regulations, policies, standards, guidelines and operational requirements.'
    },
    // RISK ASSESSMENT (RA) CONTROLS
    'RA-1': {
      name: 'Policy and Procedures',
      family: 'Risk Assessment',
      description: 'Manage and retain information within the system and information output from the system in accordance with applicable laws, executive orders, directives, regulations, policies, standards, guidelines and operational requirements.'
    },
    'RA-2': {
      name: 'Security Categorisation',
      family: 'Risk Assessment',
      description: 'Categorize the system and information it processes, stores, and transmits; Document the security categorization results, including supporting rationale, in the security plan for the system; and Verify that the authorizing official or authorizing official designated representative reviews and approves the security categorization decision.'
    },
    'RA-3': {
      name: 'Risk Assessment',
      family: 'Risk Assessment',
      description: 'Conduct comprehensive risk assessments to identify potential threats and vulnerabilities, evaluate the likelihood and impact of unauthorized activities, and assess adverse effects on individuals due to personally identifiable information processing. These assessments should integrate organizational and system-level perspectives, be documented appropriately, reviewed and disseminated at defined intervals, and updated as necessary to reflect significant changes affecting system security or privacy.'
    },
    'PL-2': {
      name: 'System Security Plan',
      family: 'Planning',
      description: 'Develop, document, and maintain a system security plan that describes the security controls in place or planned for the system, and provides the security categorization and security control implementation status.'
    },
    'RA-7': {
      name: 'Risk Response',
      family: 'Risk Assessment',
      description: 'Respond to findings from security and privacy assessments, monitoring, and audits in accordance with organizational risk tolerance.'
    },
    // SYSTEMS AND COMMUNICATION PROTECTION (SC)
    'SC-1': {
      name: 'Policy and Procedures',
      family: 'System and Communications Protection',
      description: 'The organization must develop, document, and disseminate system and communications protection policies and procedures at appropriate organizational levels (organization, mission/business process, and system). These policies must define purpose, scope, roles, responsibilities, and compliance requirements while ensuring alignment with applicable laws and regulations. A designated official must manage these documents, and both policies and procedures must be reviewed and updated at defined intervals and after specified events to maintain their effectiveness and relevance.'
    },
    'CA-1': {
      name: 'Assessment, Authorization, and Monitoring Policy and Procedures',
      family: 'Assessment, Authorization and Monitoring',
      description: 'Develop, document, and disseminate security assessment, authorization, and continuous monitoring policy and procedures that address purpose, scope, roles, responsibilities, management commitment, coordination, and compliance.'
    },
    'CA-2': {
      name: 'Control Assessments',
      family: 'Assessment, Authorization and Monitoring',
      description: 'Assess the security controls in the system and its environment of operation to determine the extent to which the controls are implemented correctly, operating as intended, and producing the desired outcome.'
    },
    'CA-5': {
      name: 'Plan of Action and Milestones',
      family: 'Assessment, Authorization and Monitoring',
      description: 'Develop a plan of action and milestones for the system to document the planned remediation actions of the organization to correct weaknesses or deficiencies noted during the assessment of the security controls and to reduce or eliminate known vulnerabilities in the system.'
    },
    'CA-7': {
      name: 'Continuous Monitoring',
      family: 'Assessment, Authorization and Monitoring',
      description: 'The organization must develop and implement a system-level continuous monitoring strategy that aligns with organizational strategy. This includes establishing and monitoring defined system metrics, conducting regular control assessments at specified frequencies, analyzing the collected information, and taking appropriate response actions based on the analysis. The strategy must ensure ongoing monitoring of both system and organizational metrics, with regular reporting of security and privacy status to designated personnel at defined intervals.'
    },
    'AU-6': {
      name: 'Audit Record Review, Analysis, and Reporting',
      family: 'Audit and Accountability',
      description: 'Review and analyze system audit records for indications of inappropriate or unusual activity, and report findings to appropriate designated personnel.'
    },
    'PS-1': {
      name: 'Personnel Security Policy and Procedures',
      family: 'Personnel Security',
      description: 'Develop, document, and disseminate personnel security policy and procedures that address purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance.'
    },
    'PS-8': {
      name: 'Personnel Sanctions',
      family: 'Personnel Security',
      description: 'Employ a formal sanctions process for individuals failing to comply with established information security and privacy policies and procedures.'
    },
    'SA-1': {
      name: 'System and Services Acquisition Policy and Procedures',
      family: 'System and Services Acquisition',
      description: 'Develop, document, and disseminate system and services acquisition policy and procedures that address purpose, scope, roles, responsibilities, management commitment, coordination among organizational entities, and compliance.'
    },
    'SA-2': {
      name: 'Allocation of Resources',
      family: 'System and Services Acquisition',
      description: 'Determine, document, and allocate the resources required to protect the system as part of its capital planning and investment control process.'
    },
    'SA-4': {
      name: 'Acquisition Process',
      family: 'System and Services Acquisition',
      description: 'Include security and privacy requirements in system acquisition contracts and monitor adherence to those requirements.'
    },
    'SR-1': {
      name: 'Policy and Procedures',
      family: 'Supply Chain Risk Management',
      description: 'Develop, document, and disseminate comprehensive supply chain risk management (SCRM) policies and procedures across appropriate organizational levels. These policies must define purpose, scope, roles, responsibilities, and compliance requirements while aligning with applicable laws and regulations. A designated official must manage these documents, and both policies and procedures must be reviewed and updated at defined intervals and following specified events to maintain their effectiveness.',
    },
    'SR-2': {
      name: 'Supply Chain Risk Management Plan',
      family: 'Supply Chain Risk Management',
      description: 'Establish and maintain a plan for managing supply chain risks throughout the entire system development life cycle, from initial research and development through to final disposal. This comprehensive plan must address risks across all stages - including design, manufacturing, acquisition, delivery, integration, operations, and maintenance - for specified systems, components, or services. The plan must be regularly reviewed and updated to address new threats or environmental changes, and appropriate protections must be in place to prevent unauthorized disclosure or modification of the plan.',
    },
    'SR-3': {
      name: 'Supply Chain Controls and Processes',
      family: 'Supply Chain Risk Management',
      description: 'Establish processes to identify and remediate vulnerabilities in supply chain elements and processes for specified systems or components. Organizations must implement designated supply chain controls to protect against risks and limit potential damage from supply chain incidents. All selected processes and controls must be formally documented in appropriate organizational plans, such as security and privacy plans or the supply chain risk management plan.',
    },
    'SR-6': {
      name: 'Supplier Assessments and Reviews',
      family: 'Supply Chain Risk Management',
      description: 'Assess and review the supply chain-related risks associated with suppliers or contractors and the system, system component, or system service they provide [Assignment: organization-defined frequency].',
    },
    'SR-7': {
      name: 'Supply Chain Operations Security',
      family: 'Supply Chain Risk Management',
      description: 'Employ the following Operations Security (OPSEC) controls to protect supply chain-related information for the system, system component, or system service: [Assignment: organization-defined OPSEC controls].',
    },
    // ZERO TRUST CONTROLS //  
    'AC-2': {
      name: 'Account Management',
      family: 'Access Control',
      description: 'Manage information system accounts, including establishing, activating, modifying, disabling, and removing accounts; reviewing accounts regularly; and implementing account management policies.',
      threat_events: [
        {
          name: 'Dictionary-based Password Attack',
          url: 'https://capec.mitre.org/data/definitions/16.html',
        },
        {
          name: 'Credential Stuffing',
          url: 'https://capec.mitre.org/data/definitions/600.html',
        },
        {
          name: 'Not Using Password Aging',
          url: 'https://cwe.mitre.org/data/definitions/262.html',
        },
      ]
    },
    'AC-3': {
      name: 'Access Enforcement',
      family: 'Access Control',
      description: 'Enforce approved authorizations for logical access to the system in accordance with applicable access control policy.',
      threat_events: [
        {name: 'Incorrect Authorisation', url: 'https://cwe.mitre.org/data/definitions/863.html'},
        {name: "Missing Authentication for Critical Function", url: "https://cwe.mitre.org/data/definitions/306.html"},
        {name: 'Remote Services with Stolen Credentials', url: 'https://capec.mitre.org/data/definitions/555.html'},
        {name: 'Accessing Data or Functionality Not Properly Constrained by ACLs', url: 'https://capec.mitre.org/data/definitions/1.html'}
      ]
    },
    'AC-4': {
      name: 'Information Flow Enforcement',
      family: 'Access Control',
      description: 'Enforce approved authorizations for controlling the flow of information within the system and between connected systems based on [Assignment: organization-defined information flow control policies].',
      threat_events: [
        {name: "Adversary in the Middle (AiTM)", url: "https://capec.mitre.org/data/definitions/94.html"},
        {name: "Sniffing Attacks", url: "https://capec.mitre.org/data/definitions/157.html"},
        {name: "Communication Channel Manipulation", url: "https://capec.mitre.org/data/definitions/216.html"},
      ]
    },
    'AC-6': {
      name: 'Least Privilege',
      family: 'Access Control',
      description: 'Employ the principle of least privilege, allowing only authorized accesses for users which are necessary to accomplish assigned tasks.'
    },
    'AC-11': {
      name: 'Session Lock',
      family: 'Access Control',
      description: 'Prevent further access to the system by initiating a session lock after a specified period of inactivity and maintain the lock until the user reestablishes access using established identification and authentication procedures.'
    },
    'AC-12': {
      name: 'Session Termination',
      family: 'Access Control',
      description: 'Automatically terminate a user session after a defined condition or trigger event (such as user logout, timeout period, or system failure) to prevent unauthorized access.'
    },
    'AC-17': {
      name: 'Remote Access Control',
      family: 'Access Control',
      description: 'Establish and document usage restrictions, configuration/connection requirements, and implementation guidance for each type of remote access allowed; and authorize each type of remote access to the system prior to allowing such connections.',
      threat_events: [
        {name: "Adversary in the Middle (AiTM)", url: "https://capec.mitre.org/data/definitions/94.html"},
        {name: "Remote Services with Stolen Credentials", url: "https://capec.mitre.org/data/definitions/555.html"},
        {name: "Session Hijacking", url: "https://capec.mitre.org/data/definitions/593.html"},
        {name: "Authentication Bypass by Spoofing", url: "https://cwe.mitre.org/data/definitions/290.html"}
      ]
    },
    'AC-18': {
      name: 'Wireless Access',
      family: 'Access Control',
      description: 'Establish usage restrictions, configuration requirements, connection requirements, and implementation guidance for wireless access, and authorize wireless access to the system prior to allowing such connections.',
      threat_events: [
        {name: "Sniffing Attacks", url: "https://capec.mitre.org/data/definitions/157.html"},
        {name: "Wi-Fi Jamming", url: "https://capec.mitre.org/data/definitions/604.html"},
        {name: "Evil Twin Wi-Fi Attack", url: "https://capec.mitre.org/data/definitions/615.html"},
      ]
    },
    'AC-19': {
      name: 'Access Control for Mobile Devices & Endpoints',
      family: 'Access Control',
      description: 'Establish configuration requirements, connection requirements, and implementation guidance for each type of mobile device and endpoint; and authorize each type of mobile device and endpoint prior to allowing such connections.'
    },
    'AC-20': {
      name: 'Use of External Information Systems',
      family: 'Access Control',
      description: 'Governs the use of external information systems, ensuring that appropriate security controls are in place when accessing organizational information or systems from non-organizational (external) devices or networks.',
      threat_events: [
        {name: "Local Execution of Code", url: "https://capec.mitre.org/data/definitions/549.html"},
        {name: "Physical Theft", url: "https://capec.mitre.org/data/definitions/507.html"},
        {name: "Retrieve Data from Decommissioned Devices", url: "https://capec.mitre.org/data/definitions/675.html"},
      ]
    },
    'AU-2': {
      name: 'Audit Events',
      family: 'Audit and Accountability',
      description: 'Determine the types of events that require auditing and configure the system to generate audit records for those events.'
    },
    'AU-9': {
      name: 'Protection of Audit Information',
      family: 'Audit and Accountability',
      description: 'Protect audit information and audit tools from unauthorized access, modification, and deletion.'
    },
    'CM-2': {
      name: 'Baseline Configuration',
      family: 'Configuration Management',
      description: 'Develop, document, and maintain under configuration control, a current baseline configuration of the information system.'
    },
    'CM-6': {
      name: 'Configuration Settings',
      family: 'Configuration Management',
      description: 'Establish and document configuration settings for information technology products employed within the information system that reflect the most restrictive mode consistent with operational requirements.'
    },
    'CM-7': {
      name: 'Least Functionality',
      family: 'Configuration Management',
      description: 'Configure the information system to provide only essential capabilities and to restrict or disable non-essential functions, ports, protocols, and services.'
    },
    'CM-8': {
      name: 'Information System Component Inventory',
      family: 'Configuration Management',
      description: 'Develop and maintain an inventory of information system components that accurately reflects the current information system, is consistent with the authorization boundary of the system, and includes all components within the boundary.'
    },
    'IA-2': {
      name: 'User Identification & Authentication',
      family: 'Identification and Authentication',
      description: 'Uniquely identify and authenticate organizational users and associate that unique identification with processes acting on behalf of those users.'
    },
    'IA-3': {
      name: 'Device Identification & Authentication',
      family: 'Identification and Authentication',
      description: 'Identify and authenticate information system devices before establishing a connection.'
    },
    'IA-4': {
      name: 'Identifier Management',
      family: 'Identification and Authentication',
      description: 'Manage system identifiers by receiving authorization from appropriate personnel to assign an identifier, selecting an identifier that identifies an individual or group, assigning the identifier to the intended party, and preventing reuse of identifiers.'
    },
    'IA-5': {
      name: 'Authenticator Management',
      family: 'Identification and Authentication',
      description: 'Manage system authenticators, ensuring secure creation, distribution, and lifecycle management of credentials.'
    },
    'IA-8': {
      name: 'Identification & Authentication (Non-Organisation Users)',
      family: 'Identification and Authentication',
      description: 'Uniquely identify and authenticate non-organizational users or processes acting on behalf of non-organizational users before allowing access to organizational systems.'
    },
    'IA-11': {
      name: 'Re-authentication',
      family: 'Identification and Authentication',
      description: 'Require users and devices to re-authenticate when organization-defined circumstances or situations require re-authentication.'
    },
    'SA-3': {
      name: 'System Development Life Cycle',
      family: 'System and Services Acquisition',
      description: 'The organization must implement a defined system development life cycle that incorporates security and privacy considerations throughout all phases. This includes clearly defining and documenting security and privacy roles and responsibilities, identifying the specific individuals responsible for these roles, and ensuring that organizational security and privacy risk management processes are fully integrated into all system development activities.',
    },
    'SA-5': {
      name: 'System Documentation',
      family: 'System and Services Acquisition',
      description: 'The organization must obtain or develop comprehensive system documentation that includes both administrator and user documentation. Administrator documentation must cover secure configuration, installation, operation, security maintenance, and known vulnerabilities. User documentation must describe security and privacy functions, secure usage methods, and user responsibilities. When documentation is unavailable or nonexistent, attempts to obtain it must be documented and defined actions taken. All documentation must be distributed to appropriate personnel or roles.',
    },
    'SA-8': {
      name: 'Security and Privacy Engineering Principles',
      family: 'System and Services Acquisition',
      description: 'Apply the following systems security and privacy engineering principles in the specification, design, development, implementation, and modification of the system and system components: [Assignment: organization-defined systems security and privacy engineering principles].',
    },
    'SA-9': {
      name: 'External System Services',
      family: 'System and Services Acquisition',
      description: "The organization must establish and enforce security and privacy requirements for external system service providers, including specific required controls. The organization must clearly define and document oversight responsibilities and user roles related to external services. Additionally, specific processes, methods, and techniques must be implemented to continuously monitor external service providers' compliance with these requirements.",
    },
    'SA-10': {
      name: 'Developer Configuration Management',
      family: 'System and Services Acquisition',
      description: 'The organization must require system developers to implement configuration management throughout the system lifecycle, including design, development, implementation, operation, and disposal phases. Developers must document and control changes to defined configuration items, implement only organization-approved changes, document these changes and their potential security and privacy impacts, and maintain tracking of security flaws and their resolution, reporting findings to designated personnel.',
    },
    'SA-11': {
      name: 'Developer Testing and Evaluation',
      family: 'System and Services Acquisition',
      description: 'The organization must require system developers to perform ongoing security and privacy assessments throughout all post-design stages of development. This includes implementing a comprehensive testing plan with specified types of testing (unit, integration, system, and/or regression) at defined frequencies and coverage levels. Developers must document the execution of the assessment plan and test results, implement a verifiable flaw remediation process, and correct identified flaws during testing and evaluation.',
    },
    'SA-15': {
      name: 'Development Process, Standards, and Tools',
      family: 'System and Services Acquisition',
      description: 'This control requires organizations to establish and oversee a documented software development process that emphasizes security and privacy throughout the development lifecycle. Developers must explicitly incorporate security and privacy requirements, specify all development tools and standards being used, document specific tool configurations, and maintain change control over both the process and tooling. Organizations must also conduct periodic reviews of the entire development environment - including the process, standards, tools, and configurations - to verify it meets defined security and privacy requirements.',
    },
    'SA-17': {
      name: 'Developer Security and Privacy Architecture and Design',
      family: 'System and Services Acquisition',
      description: "System developers must create detailed design specifications and security/privacy architectures that align with the organization's broader enterprise architecture. These specifications must comprehensively document all security and privacy functionality, clearly map controls across physical and logical system components, and explain how various security and privacy mechanisms interact cohesively to deliver required protective capabilities.",
    },
    'SC-5': {
      name: 'Denial of Service Protection',
      family: 'System and Communications Protection',
      description: 'Implements measures to protect the system against denial-of-service (DoS) attacks, ensuring that critical resources remain available and functional even under attack conditions.',
      threat_events: [
        {name: "Flooding", url: "https://capec.mitre.org/data/definitions/125.html"},
        {name: "Excessive Allocation", url: "https://capec.mitre.org/data/definitions/130.html"},
        {name: "Allocation of Resources Without Limits or Throttling", url: "https://cwe.mitre.org/data/definitions/770.html"},
      ]
    },
    'SC-7': {
      name: 'Boundary Protection',
      family: 'System and Communications Protection',
      description: 'Establishes protections at the network boundaries by using firewalls, gateways, and intrusion prevention systems to control and monitor information flow and prevent unauthorized access between different network segments.'
    },
    'SC-8': {
      name: 'Transmission Confidentiality & Integrity',
      family: 'System and Communications Protection',
      description: 'Ensures that data transmitted across networks remains confidential and unaltered during transmission by implementing encryption and other protective measures.'
    },
    'SC-10': {
      name: 'Network Disconnect',
      family: 'System and Communications Protection',
      description: 'Terminate the network connection associated with a communications session at the end of the session or after a defined period of inactivity to prevent unauthorized access and use of sessions.'
    },
    'SC-12': {
      name: 'Cryptographic Key Establishment & Management',
      family: 'System and Communications Protection',
      description: 'Establishes and manages cryptographic keys used for encryption, ensuring secure generation, distribution, storage, and lifecycle management of keys.'
    },
    'SC-13': {
      name: 'Cryptographic Protection',
      family: 'System and Communications Protection',
      description: 'Provides mechanisms to protect information through encryption, safeguarding data confidentiality and integrity, whether in storage or in transit.'
    },
    'SC-18': {
      name: 'Mobile Code',
      family: 'System and Communications Protection',
      description: 'Define security policies for the use of mobile code and establish configuration requirements for the execution of mobile code in information systems.'
    },
    'SC-23': {
      name: 'Session Authenticity',
      family: 'System and Communications Protection',
      description: 'Protect the authenticity of communications sessions by generating unique session identifiers, recognizing only valid session identifiers, and protecting the integrity of session identifiers during transmission.'
    },
    'SC-28': {
      name: 'Protection of Information at Rest',
      family: 'System and Communications Protection',
      description: 'Protects sensitive data that is stored on physical media from unauthorized access or modification, typically using encryption and access controls.'
    },
    'SC-39': {
      name: 'Process Isolation',
      family: 'System and Communications Protection',
      description: 'Ensures that processes running in an information system are isolated from each other to prevent unintended information exchange or interference.'
    },
    'SI-3': {
      name: 'Malicious Code Protection',
      family: 'System and Information Integrity',
      description: 'Detects and prevents malicious software (malware) from executing in the system using antivirus programs, intrusion detection, and security monitoring tools.'
    },
    'SI-4': {
      name: 'Information System Monitoring',
      family: 'System and Information Integrity',
      description: 'Monitors information systems for unusual or suspicious activity to detect and respond to unauthorized access, ensuring the integrity and security of the system.'
    },
    'SC-3': {
      name: 'Security Function Isolation',
      family: 'System and Communications Protection',
      description: 'The system isolates security functions from nonsecurity functions. This includes isolating security-related system components and services from other system components and services to enhance protection and system maintainability.',
      threat_events: [
        {name: "Using Malicious Files", url: "https://capec.mitre.org/data/definitions/17.html"},
        {name: "Privilege Escalation", url: "https://capec.mitre.org/data/definitions/233.html"},
        {name: "Target Programs with Elevated Privileges", url: "https://capec.mitre.org/data/definitions/69.html"},
        {name: "Improper Isolation or Compartmentalization", url: "https://cwe.mitre.org/data/definitions/653.html"},
      ]
    },
    'SC-4': {
      name: 'Information in Shared System Resources',
      family: 'System and Communications Protection',
      description: 'The system prevents unauthorized and unintended information transfer via shared system resources. This includes preventing data or information leakage between information system processes sharing storage or other resources.'
    },
    'SC-6': {
      name: 'Resource Availability',
      family: 'System and Communications Protection',
      description: 'The system protects the availability of resources by allocating system resources based on priority and quota. This includes preventing lower-priority processes from delaying or interfering with higher-priority processes.'
    },
    'SC-15': {
      name: 'Collaborative Computing Devices',
      family: 'System and Communications Protection',
      description: 'The system prohibits remote activation of collaborative computing devices and provides an explicit indication of use to users physically present at the devices. This includes controlling devices such as cameras, microphones, and conferencing systems.'
    },
    'SC-20': {
      name: 'Secure Name/Address Resolution Service (Authoritative Source)',
      family: 'System and Communications Protection',
      description: 'The system provides additional data origin authentication and integrity verification artifacts along with the authoritative name resolution data the system returns in response to external name/address resolution queries.'
    },
    'SC-21': {
      name: 'Secure Name/Address Resolution Service (Recursive or Caching Resolver)',
      family: 'System and Communications Protection',
      description: 'The system requests and performs data origin authentication and data integrity verification on the name/address resolution responses the system receives from authoritative sources.'
    },
    'SC-31': {
      name: 'Covert Channel Analysis',
      family: 'System and Communications Protection',
      description: 'The organization performs covert channel analysis to identify aspects of communications within the system that are potential avenues for covert storage and timing channels, and estimates the maximum bandwidth of those channels.'
    },
    'SC-32': {
      name: 'System Partitioning',
      family: 'System and Communications Protection',
      description: 'The organization partitions the system into components residing in separate physical or logical domains or environments based on criticality and sensitivity. This includes implementing separate physical or logical security domains to isolate critical system components.'
    },
    'SC-35': {
      name: 'External Malicious Code Identification',
      family: 'System and Communications Protection',
      description: 'The system includes system components that proactively seek to identify network-based malicious code or malicious network communications. This includes capabilities to detect and analyze incoming communications and code for malicious content.'
    },
    'SC-36': {
      name: 'Distributed Processing and Storage',
      family: 'System and Communications Protection',
      description: 'The organization distributes processing and storage across multiple physical locations. This includes implementing distributed processing and storage to reduce the risk of a single point of failure.'
    },
    'SC-37': {
      name: 'Out-of-Band Channels',
      family: 'System and Communications Protection',
      description: 'The organization employs out-of-band channels for the physical delivery or electronic transmission of information, system components, or devices to individuals or systems. This includes using separate physical or logical communication paths for system operations and management.'
    },
    'SC-40': {
      name: 'Wireless Link Protection',
      family: 'System and Communications Protection',
      description: 'The system protects external and internal wireless links from signal parameter attacks, jamming, and electromagnetic interference. This includes implementing wireless security features and monitoring for unauthorized wireless connections.'
    },
    'SC-47': {
      name: 'Alternative Physical Protection',
      family: 'System and Communications Protection',
      description: 'The organization employs alternative physical security mechanisms to protect organizational systems, system components, and devices when primary physical security mechanisms are not available or compromised.'
    },
    'SI-2': {
      name: 'Flaw Remediation',
      family: 'System and Information Integrity',
      description: 'The organization identifies, reports, and corrects system flaws; tests software and firmware updates related to flaw remediation for effectiveness and potential side effects; installs security-relevant software and firmware updates; and incorporates flaw remediation into the organizational configuration management process.'
    },
    'SI-5': {
      name: 'Security Alerts, Advisories, and Directives',
      family: 'System and Information Integrity',
      description: 'The organization receives system security alerts, advisories, and directives from designated external organizations on an ongoing basis; generates internal security alerts, advisories, and directives as deemed necessary; disseminates security alerts, advisories, and directives to appropriate personnel and external organizations; and implements security directives in accordance with established time frames.'
    },
    'SI-6': {
      name: 'Security Function Verification',
      family: 'System and Information Integrity',
      description: 'The system verifies the correct operation of security functions; performs this verification upon system startup and restart, upon command by user with appropriate privilege, and periodically; notifies system administrators when anomalies are discovered; and shuts the system down, restarts the system, or triggers other responses when anomalies are discovered.'
    },
    'SI-7': {
      name: 'Software, Firmware, and Information Integrity',
      family: 'System and Information Integrity',
      description: 'The system employs integrity verification tools to detect unauthorized changes to software, firmware, and information. This includes implementing cryptographic mechanisms to detect unauthorized changes, automated tools to perform integrity checks, and security-relevant events notification when discrepancies are discovered.'
    },
    'SI-10': {
      name: 'Information Input Validation',
      family: 'System and Information Integrity',
      description: 'The system checks the validity of information inputs through various means such as checking inputs for correct syntax, length, range, and format. This includes validating inputs to ensure they conform to specified definitions for format and content to prevent attacks such as buffer overflows and injection attacks.'
    },
    'SI-14': {
      name: 'Non-Persistence',
      family: 'System and Information Integrity',
      description: 'The system implements non-persistent components and services that are initiated in a known state and terminated upon end of session. This includes transitioning components and services to a known secure state on completion and removing or redefining security-critical components within defined time periods.'
  }
  };